export default __webpack_public_path__ + "static/media/LeakedSession_Dashboard.0677c8c7.svg";